import React from 'react';

import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import EmDash from '../emdash';

const PlacementInfo = ({ label, value }: { label: string; value?: string | number }) => {
  return (
    <Column spacing="100">
      <Text color="secondary">{label}</Text>
      <Text>{value ?? <EmDash />}</Text>
    </Column>
  );
};

export default PlacementInfo;
